import { get } from 'lodash'
import { flow, Instance, types } from 'mobx-state-tree'
import { getCodeNames } from '../../network/getCodeNames'
import { menuInfo } from '../../network/menuInfo'
import { getErrorMessage, MessageTypes } from '../../utils'
import { RootStore } from '../store'

const User = types
  .model('User', {
    id: types.optional(types.number, 0),
    name: types.optional(types.string, ''),
    token: types.optional(types.string, ''),
    expiresAt: types.optional(types.string, ''),
    group: types.optional(types.string, ''),
    type: types.optional(types.string, ''),
    accessConfig: types.optional(types.string, '{}'),
    lastLogin: types.optional(types.string, ''),
    createdBy: types.optional(types.string, ''),
    createdDate: types.optional(types.string, ''),
    status: types.optional(types.string, 'Active'),
  })
  .actions((self) => ({
    resetToken() {
      self.token = ''
      self.expiresAt = ''
      self.group = ''
      self.accessConfig = '{}'
      self.name = ''
      self.id = 0
      const isCitrixIp = localStorage.getItem('isCitrixIp')
      localStorage.clear()
      localStorage.setItem('isCitrixIp', isCitrixIp)
    },
    setSession(token: string, expiresAt: string, accessConfig: string, name: string, id: number) {
      const own = self
      own.token = token
      own.expiresAt = expiresAt
      own.accessConfig = accessConfig
      own.name = name
      own.id = id
    },
    fetchCodeNames: flow(function* fetchCodeNames(type: any) {
      try {
        const response = yield getCodeNames(type, RootStore.session.getTokens)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    setUserName(name: string) {
      self.name = name
    },
    updateAccessConfig(access: string) {
      self.accessConfig = access
    },
    fetchUserDetails: flow(function* fetchUserDetails() {
      try {
        const response: any = yield menuInfo(self.name, RootStore.session?.getTokens)
        self.accessConfig = JSON.stringify(response?.accessConfig ?? '{}')
        self.name = response.name
        localStorage.setItem('accessConfig', JSON.stringify(response?.accessConfig))
        return response
      } catch (error) {
        RootStore.message.setMessage(error.message, MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getAccessConfig(data: string[]) {
      try {
        const access = JSON.parse(self.accessConfig)
        return get(access, data, null)
      } catch (error) {}
    },
    getDefaultUserConfigs() {
      const config = self?.accessConfig && JSON.parse(self?.accessConfig)
      const keys = Object.keys(config)
      const retArr: any = []
      keys.map((key: any) => {
        if (key !== 'access_management') {
          const subTitles = Object.keys(config[key].data)
          const subTitlesArray: any = []
          subTitles.map((subTitle: any) => {
            if (subTitle !== 'isAccessible') {
              const subTitleData = {
                title: subTitle,
                titleAccessible: false,
                fetch: false,
                add: false,
                approve: false,
                delete: false,
              }
              subTitlesArray.push(subTitleData)
            }
          })
          const data = {
            title: key,
            titleAccessible: false,
            subTitleData: subTitlesArray,
          }
          retArr.push(data)
        }
      })

      return { ...self, name: '', id: undefined, accessConfig: retArr }
    },
  }))

export type UserType = Instance<typeof User>
export { User, userData }

const userData = User.create({
  id: 0,
  name: '',
  token: '',
  expiresAt: '',
  group: '',
  accessConfig: '{}',
  createdBy: '',
  createdDate: '',
  status: 'Active',
})

// const Config = types.model('Config', {
//   type: types.identifier,
//   isAccessible: types.boolean,
//   icon: types.string,
//   link: types.string,
//   title: types.string,
// })

// const Access = types.model('Access', {
//   type: types.identifier,
//   data: types.map(Config),
//   isAccessible: types.boolean,
//   icon: types.string,
//   link: types.string,
//   title: types.string,
// })

// const AccessConfig = types.model('AccessConfig', {
//   isAccessible: types.boolean,
//   data: types.map(Access),
//   icon: types.string,
//   link: types.string,
//   title: types.string,
// })

// const GroupAccess = types.model('GroupAccess', {
//   isAccessible: types.boolean,
//   id: types.identifier,
//   add: types.boolean,
//   delete: types.boolean,
//   update: types.boolean,
//   fetch: types.boolean,
// })

// const GroupAccessConfig = types.model('GroupAccessConfig', {
//   isAccessible: types.boolean,
//   config: types.map(GroupAccess),
// })

// const Group = types.model('Group', {
//   id: types.number,
//   type: types.string,
//   name: types.string,
//   accessConfig: types.map(GroupAccessConfig),
// })
